module.exports = __webpack_public_path__ + "static/media/message-list.d7b70182.svg";